<div
  class="{{ classNames }} {{
    isIcon
      ? 'transition-all w-10 h-10 hover:bg-black hover:bg-opacity-30 rounded-full flex items-center justify-center cursor-pointer'
      : ''
  }}">
  <img appImg class="images {{ imgClass }}" src="{{ img }}" />
</div>
